import { create } from "zustand";

export const useSurveyStore = create((set) => ({
	token: null,
	userId: null,
	surveyId: null,
	complianceText: "",
	questions: [],
	complianceInput: "",
	complianceTimestamp: null,
	initTimestamp: null,
	answers: {},
	errorCode: null,
	surveyTitle: "",
	surveySubTitle: "",
	surveyIntroTextHtml: "",
	setUserId: (userId) => set({ userId }),
	setSurveyId: (surveyId) => set({ surveyId }),
	setToken: (token) => set({ token }),
	setComplianceText: (text) => set({ complianceText: text }),
	setQuestions: (questions) => set({ questions }),
	setComplianceInput: (input) => set({ complianceInput: input }),
	setComplianceTimestamp: (timestamp) => set({ complianceTimestamp: timestamp }),
	setInitTimestamp: (timestamp) => set({ initTimestamp: timestamp }),
	setErrorCode: (code) => set({ errorCode: code }),
	setSurveyTitle: (title) => set({ surveyTitle: title }),
	setSurveySubTitle: (subTitle) => set({ surveySubTitle: subTitle }),
	setSurveyIntroTextHtml: (introTextHtml) => set({ surveyIntroTextHtml: introTextHtml }),
	setAnswer: (questionId, value) =>
		set((state) => ({
			answers: { ...state.answers, [questionId]: value },
		})),
}));
